import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { InvoiceSettingResponse, InvoiceSettingRequest } from '@business/entities/invoiceSetting';
import { InvoiceSettingAPI } from '@business/api/invoice';

export class InvoiceSettingBloc extends BaseBloc {
  private readonly invoiceRepo = new Repository<InvoiceSettingResponse>({
    getItemId: item => item.id,
  });

  readonly settings = this.invoiceRepo.selectItem;

  onReset() {
    this.invoiceRepo.reset();
  }

  fetchSettings = (objectId: string, type: string) => {
    return InvoiceSettingAPI.fetchSettings(objectId, type).pipe(
      this.invoiceRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_invoice_settings') }),
    );
  };

  saveSettings = (data: InvoiceSettingRequest) => {
    return InvoiceSettingAPI.saveSettings(data).pipe(
      this.invoiceRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('save_invoice_settings'),
      }),
    );
  };
}
